// extracted by mini-css-extract-plugin
export default {"container":"styles_container__S5ttc","logo":"styles_logo__Ekmkr","label":"styles_label__M3Ads"};